<template>
  <div class="brand-detection__card-btns">
    <el-button
      class="action-button"
      @click="$emit('settings', $event, video.id)">
      <svgicon name="Setting" />
    </el-button>
    <el-button
      class="action-button"
      @click="$router.push({ name: 'frame-view', params: { projectId: $route.params.projectId, videoId: video.id, type: 'brand_detection'}})">
      <svgicon name="crop" color="var(--primary)" style="opacity: 0.6" />
    </el-button>
    <el-dropdown trigger="hover" @command="$emit('download', $event, `(${video.video_name})`, video)">
      <div class="brand-detection__card-export">
        <span style="margin-top: -2px">Export</span>
        <div class="brand-detection__card-export-select">
          <svgicon name="ArrowDown" />
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="pdf">PDF</el-dropdown-item>
        <el-dropdown-item command="csv">CSV</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "VideoActions",
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
}
</script>
